import { render, staticRenderFns } from "./AddRelatedUser.vue?vue&type=template&id=b3b0f69c&"
import script from "./AddRelatedUser.vue?vue&type=script&lang=js&"
export * from "./AddRelatedUser.vue?vue&type=script&lang=js&"
import style0 from "./AddRelatedUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports